import React, { useEffect, useState } from 'react';
import { requestUserPasswordReset, resetForgotPasswordForm } from '../../../../actions/user';
import { forceValidation, clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import { updateShowforgetPasswordModal } from '../../../../actions/modal';
import { useDispatch } from 'react-redux';

const RightPanelForgotPassword = (props) => {
  const dispatch = useDispatch();
  let [resetButtonClasses, setResetButtonClasses] = useState(
    'ui labeled icon button icon color-button color-button-hover color-white  max-width left-text mrlnull mrbnull disable'
  );

  useEffect(() => {
    let innterResetClasses =
      props.resetingPassword == true ? resetButtonClasses + ' loading' : resetButtonClasses.replace(' loading');

    setResetButtonClasses(innterResetClasses);
  }, [props.resetingPassword]);

  useEffect(() => {
    resetForm();
  }, []);

  const requestNewPassword = (e) => {
    let areThereErrors = forceValidation(undefined, undefined, 'forgotPasswordForm');
    if (!areThereErrors && !window.$(e.target).hasClass('disable')) {
      dispatch(requestUserPasswordReset(props.userEmail));
    }
  };
  const cancelResetPassword = () => {
    resetForm();
    dispatch(updateShowforgetPasswordModal(false));
  };

  const resetForm = () => {
    //TODO : HERE WE USED TO CLEAR THE DROPDOWN, VERIFY WE STILL NEED THAT   window.$('.forgot-password.modal .ui.dropdown').dropdown('clear')
    setTimeout(() => {
      dispatch(resetForgotPasswordForm());
    }, 100); //wait until modal is inviisble
  };

  let cancelClassName =
    'ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mrtsss';
  if (!props.passwordResetRequestCompleted) {
    cancelClassName +=
      ' ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mrtm';
  }
  return (
    <div>
      <div className="ui actions mrbl max-width">
        <button
          tabIndex="1"
          type="button"
          data-show={!props.passwordResetRequestCompleted}
          onClick={requestNewPassword}
          data-group="forgotPasswordForm"
          className={resetButtonClasses}
        >
          <i className="send outline icon" />
          {APP.LANGUAGE.ForgotPassword.ForgotButton}
        </button>
        <button tabIndex="2" type="button" onClick={cancelResetPassword} className={cancelClassName}>
          <i className="remove  icon" />
          {!props.passwordResetRequestCompleted ? APP.LANGUAGE.Cancel : APP.LANGUAGE.Close}
        </button>
      </div>
    </div>
  );
};

export default RightPanelForgotPassword;
